import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import {dizionarioTraduzioni} from "../../../funzioni/traduzioni";
import "@fortawesome/fontawesome-free/css/all.min.css"
import { useEffect} from "react";
import {getLingua} from "../../../auth";
/* global $ */
function TabsPacchetti({ onChange }) {
    const lingua=getLingua()
const tabsIconAndText2 = [
      { id: 0, text: dizionarioTraduzioni(lingua,'Tutti'), icon: "fa-solid fa-people-group" },
      { id: 1, text: dizionarioTraduzioni(lingua,'Pacchetti Conclusi'), icon: "fa-solid fa-lock" },
      { id: 2, text: dizionarioTraduzioni(lingua,'Pacchetti Aperti'), icon: "fa-solid fa-unlock" },
    ];
    useEffect(() => {
    const tabs2 =$('#concluseNo').dxTabs({
      width: '100%',
      rtlEnabled: false,
      showNavButtons: false,
      dataSource: tabsIconAndText2,
      orientation: "horizontal",
      stylingMode: "primary",
      iconPosition: "top",
      onSelectionChanged: function (e) {const newIndex = e.component.option("selectedIndex");
        onChange(newIndex);
    },
      itemTemplate: function (itemData) {
          return `<div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
          <div>${itemData.text}</div><i class="${itemData.icon}" style="font-size: 20px;"></i>
          </div>`;
        },
    }).dxTabs('instance');
    tabs2.option("selectedIndex", 0)
    onChange(0)
    },[onChange])
    return <div id="concluseNo" ></div>

}
export default TabsPacchetti
